module.exports = "/_next/static/images/de-footer-logo-ea4861f5db299473855ba9597346e75c.svg";